export default "__VITE_ASSET__dGOLjZyx__"